import React from 'react';
import { useTranslation } from 'react-i18next';
import RegistrationErrorLayout from 'Components/Layouts/Authorization/RegistrationErrorLayout';

export default function RegistrationErrorInvalid() {
    const { t } = useTranslation();
    return (
        <RegistrationErrorLayout
            title={t('signUpError.invalidTitle')}
            description={t('signUpError.invalidDescription')}
        />
    );
}